import { idb } from "../db/index.ts";
import type { UpdateEvents, ViewInput } from "../../common/types.ts";

const updateDashboard = async (
	inputs: ViewInput<"dashboard">,
	updateEvents: UpdateEvents,
) => {
	if (updateEvents.includes("firstRun") || updateEvents.includes("leagues")) {
		const leagues = await idb.meta.getAll("leagues");

		for (const league of leagues) {
			league.teamRegion ??= "???";
			league.teamName ??= "???";
		}

		return {
			leagues,
			// Executive Challenge invite deep link /c/{code} — GmStart opens the
			// join sheet with this code prefilled.
			joinCode: inputs.joinCode,
		};
	}
};

export default updateDashboard;
